import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  Renderer2,
  ViewChildren,
} from '@angular/core';
import { DocumentclickDirective } from 'src/app/common/directives/documentclick.directive';
import { SnapshotService } from '../Services/snapshot.service';
import { LoaderService } from '../../../common/services/loader.service';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { ConditionalExpr } from '@angular/compiler';
import * as _ from 'lodash';

@Component({
  selector: 'app-standard-widget-library',
  templateUrl: './standard-widget-library.component.html',
  styleUrls: ['./standard-widget-library.component.css'],
})
export class StandardWidgetLibraryComponent implements OnInit, AfterViewInit {
  @ViewChildren('select') selectElement!: HTMLElement;
  @ViewChildren('options') optionsElements!: QueryList<ElementRef>;
  [x: string]: any;
  snapConfig: any;
  widgetInfo: any;
  productSelected = '';
  templateSelected = '';
  snapshotTypes: any[] = [];
  sections: any[] = [];
  subSections: any[] = [];
  distinctPages: any[] = [];
  groupedByPage: any[] = [];
  pageCounter: number = 1;
  metricdata: any;
  metricgroup: any;
  metrics: any;
  uniqueMetricsWithTrend: any;
  groupedData: any;
  groupedData1: any;
  searchmetric: string = '';
  typeHeader = 'Snapshot Types';
  sectionHeader = 'Sections';
  subSectionHeader = 'Sub Sections';
  pageTableData: any = [];
  existingData: any = [];
  isExisting: boolean = true;
  showErrorPopUp = false;
  popUpMessage: any = '';
  errorheaderTitle: any = '';
  popUpTitle: string = "Error";
  showConfirmationPopUp: boolean = false;
  constructor(
    private _configData: SnapshotService,
    private _loaderService: LoaderService,
    private eRef: ElementRef,
    private clientDetails: SnapshotSharedVariablesService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) { }


  ngOnInit(): void {
    this.disableLeftClick = true;
    this._loaderService.showLoader();
    let data = {
      "clientName": this.clientDetails.clientDetails.client_name,
      "snapshotName": this.clientDetails.clientDetails.study
    }
    this._configData.getWidgetLibraryConfiguration(data).subscribe((r: any) => {
      // 
      if (r.Data) {
        this.existingData = JSON.parse(r.Data);
      }
      else {
        this.existingData = [];
      }
      this.widgetDatacall();
    })

  }

  renderWidgetConfigurationOnSubmit() {
    let data = {
      "clientName": this.clientDetails.clientDetails.client_name,
      "snapshotName": this.clientDetails.clientDetails.study
    }
    this._configData.getWidgetLibraryConfiguration(data).subscribe((r: any) => {
      // 
      if (r.Data) {
        this.existingData = JSON.parse(r.Data);
      }
      else {
        this.existingData = [];
      }
      // this.widgetDatacall();
    })
  }



  metricGroupLength: number = 0;
  widgetDatacall() {
    this._configData.getWidgetInfo().subscribe((data: any) => {

      this.widgetInfo = JSON.parse(data.Data);
      // 
      // 
      this.productSelected =
        this._configData.clientSnapshotSelectedData?.product;
      this.templateSelected =
        this._configData.clientSnapshotSelectedData?.product_type;
      ;
      // 
      this.widgetInfo = this.widgetInfo.filter(
        (item: any) =>
          item.product.trim() === this.productSelected.trim() &&
          item.template.trim() === this.templateSelected.trim()
      );
      // 
      this.snapConfig =
        this._configData.clientSnapshotSelectedData.snapshotType_details;
      ;
      for (let i = 0; i < this.snapConfig.length; i++) {
        this.snapshotTypes.push({
          name: this.snapConfig[i].snapshot_type,
          value: this.snapConfig[i].snapshot_type,
          selected: false,
        });
      }
      //// 

      // Step 1: Find distinct page values and sort them
      this.distinctPages = [
        ...new Set(
          this.widgetInfo
            .map((item: any) => item.page)
            .filter((page: any) => page !== null)
        ),
      ].sort();

      ////  // Output: ["Page 1", "Page 2"]

      // Step 2: Group objects by distinct page values
      // this.groupedByPage = this.distinctPages.map(page => ({
      //   page,
      //   items: this.widgetInfo.filter((item: any) => item.page === page)
      // }));
      this.groupedByPage = this.distinctPages.map((page) => {
        const pageItems = this.widgetInfo.filter(
          (item: any) => item.page === page
        );
        const uniqueCombos = new Set();
        // Filter items to ensure only unique combinations(widget_no, snapshot_type, section, and sub_section) are included
        const items = pageItems.filter((item: any) => {
          const combo = `${item.widget_no}-${item.snapshot_type}-${item.section}-${item.sub_section}`;
          if (!uniqueCombos.has(combo)) {
            uniqueCombos.add(combo);
            return true;
          }
          return false;
        });

        return { page, items };
      });

      ;
      let x = this.groupedByPage;
      let y = [];
      for (let z = 0; z < x.length; z++) {
        if (x[z].page !== 'NA') {
          y.push(x[z]);
        }
      }
      this.groupedByPage = y;
      // 
      let data1 = {
        client_code: this.clientDetails.clientDetails.client_name,
        study_name: this.clientDetails.clientDetails.selectedStudy,
      };
      // 
      this._configData
        .getWidgetLibraryMetricList(data1)
        .subscribe((data: any) => {
          this.metricdata = JSON.parse(data.Data);
          this.metricdata = this.metricdata.filter((item: any) => item['Is_snapshot'] === 1);
          // 

          this.metricGroupLength = this.metricdata.filter((a: any) => a.WidgetMapping_VariableGroups != "").length;

          if (this.metricGroupLength != 0) {
            this.metricgroup = Array.from(
              new Set(
                this.metricdata.map(
                  (item: any) => item['WidgetMapping_VariableGroups']
                )
              )
            );
          }

          this.metrics = Array.from(
            new Set(
              this.metricdata.map(
                (item: any) => item['WidgetMapping_Variables']
              )
            )
          );
          this.uniqueMetricsWithTrend = Array.from(
            new Map(
              this.metricdata.map((item: any) => [
                `${item.WidgetMapping_Variables}-${item.Trend_Flag}`,
                { WidgetMapping_Variables: item.WidgetMapping_Variables, Trend_Flag: item.Trend_Flag }
              ])
            ).values()
          );
          let brandanalysis: any = {};
          this.metrics.forEach((m: any) => {
            const foundItem = this.metricdata.find((m1: any) => m1['WidgetMapping_Variables'] === m);
            if (foundItem) {
              const isBrandAnalysisValue = foundItem['is_brandanalysis'];
              brandanalysis[m] = isBrandAnalysisValue;
              // Or store the result in another array or object as needed
            }
          });
          // 
          this.metrics = this.metrics.map((m: any) => ({
            option: m,
            isSelected: false,
            selectorder: 0,
            isBrandAnalysis: brandanalysis[m]
          }));
          // 
          // 
          this.groupedData1 = this.getGroupedData(this.metricdata);
          this.groupedData1.forEach((item: any) => {
            item.option = item.metricgroup;
            item.Level2 = item.metrics.map((m: any) => ({
              option: m,
              isSelected: false,
              selectorder: 0,
            }));
            item.type = 'checkbox';
            item.isDropdownOpen = false;
          });

          this.groupedData = [{
            option: "METRIC GROUP",
            isDropdownOpen: false,
            type: "radio",
            Level2: this.metricgroup?.map((m: any) => ({
              option: m,
              isSelected: false,
              selectorder: 0
            }))
          },
          {
            option: "METRICS",
            isDropdownOpen: false,
            type: "checkbox",
            Level2: this.metrics
          }
          ]
          // 
          // 
          this.generateTableData();
          this._loaderService.hideLoader();
        });

      // Log the grouped objects
      //// 
    });
  }

  getGroupedData(
    data: {
      WidgetMapping_Variables: string;
      WidgetMapping_VariableGroups: string;
    }[]
  ): { metricgroup: string; metrics: string[] }[] {
    const groups: { [key: string]: Set<string> } = {};

    data.forEach((item) => {
      if (!groups[item.WidgetMapping_VariableGroups]) {
        groups[item.WidgetMapping_VariableGroups] = new Set();
      }
      groups[item.WidgetMapping_VariableGroups].add(
        item.WidgetMapping_Variables
      );
    });

    const result: { metricgroup: string; metrics: string[] }[] = [];

    for (const group in groups) {
      if (groups.hasOwnProperty(group)) {
        result.push({
          metricgroup: group,
          metrics: Array.from(groups[group]),
        });
      }
    }

    return result;
  }




  ngAfterViewInit() { }

  // sections: any = [
  //   { name: "section1", value: "section1", selected: false },
  //   { name: "section2", value: "section2", selected: true },
  //   { name: "section3", value: "section3", selected: false }
  // ];

  // subSections: any = [
  //   { name: "sub1", value: "sub1", selected: false },
  //   { name: "sub2", value: "sub2", selected: false },
  //   { name: "sub3", value: "sub3", selected: true }
  // ];
  typeDropdownPopup: boolean = false;
  sectionDropdownPopup: boolean = false;
  subSectionDropdownPopup: boolean = false;

  openTypeDropdown(event: Event): void {
    this.typeDropdownPopup = !this.typeDropdownPopup;
    this.sectionDropdownPopup = false;
    this.subSectionDropdownPopup = false;
    event.stopPropagation();
  }

  openSectionDropdown(event: Event): void {
    this.sectionDropdownPopup = !this.sectionDropdownPopup;
    this.typeDropdownPopup = false;
    this.subSectionDropdownPopup = false;
    event.stopPropagation();
  }

  openSubsectionDropdown(event: Event): void {
    this.subSectionDropdownPopup = !this.subSectionDropdownPopup;
    this.sectionDropdownPopup = false;
    this.typeDropdownPopup = false;
    event.stopPropagation();
  }
  closeTypeDropdown(): void {
    this.typeDropdownPopup = false;
  }
  closeSectionDropdown() {
    this.sectionDropdownPopup = false;
  }
  closeSubsectionDropdown() {
    this.subSectionDropdownPopup = false;
  }

  sectionDisable: boolean = true;
  subSectionDisable: boolean = true;
  selectedSnapshotType: any;
  isWidgetTypeSectionsConfigured: boolean = false;
  onTypeClick(item: any) {
    for (let i = 0; i < this.snapshotTypes.length; i++) {
      if (
        this.snapshotTypes[i] === item &&
        this.snapshotTypes[i].selected == true
      ) {
        // this.snapshotTypes[i].selected = false;
      } else if (this.snapshotTypes[i] === item) {
        this.snapshotTypes[i].selected = true;
      } else {
        this.snapshotTypes[i].selected = false;
      }
    }
    //If nothing is selected in snapshot type dropdown then disbale the section and subSection
    let count = 0;
    for (let z = 0; z < this.snapshotTypes.length; z++) {
      if (this.snapshotTypes[z].selected == true) {
        count++;
      }
    }
    if (count == 0) {
      this.sectionDisable = true;
      this.subSectionDisable = true;
      this.sections = [];
      this.subSections = [];
    } else {
      this.subSections = [];
    }

    // ------Find the selected snapshot type
    const selectedSnapshotType = this.snapshotTypes.find(
      (snapshotType) => snapshotType.selected
    );
    this.selectedSnapshotType = selectedSnapshotType;
    if (selectedSnapshotType) {
      let selectedName = selectedSnapshotType.name;
      // if (selectedName == "Multiple Brands") {
      //   selectedName = "Multiple Brands"
      // }
      // --------Filter widgetInfo based on snapshot_type
      let matchingWidgets = this.widgetInfo.filter((widget: any) => {
        return widget.snapshot_type === selectedName;
      });

      //

      // -----Extract unique sections
      const sectionss = matchingWidgets.map((widget: any) => widget.section);
      let uniqueSections = [...new Set(sectionss)];
      //
      uniqueSections = uniqueSections.filter((item) => item !== 'NA'); //Removing NA field

      this.sections = [];
      for (let i = 0; i < uniqueSections.length; i++) {
        this.sections.push({
          name: uniqueSections[i],
          value: uniqueSections[i],
          selected: false,
        });
      }

      // Enabling and disabling section and subSection div
      if (uniqueSections.length > 0) {
        this.sectionDisable = false;
        this.subSectionDisable = true;
        this.tableData = [];
        this.pageTableData = [];
        this.selectedSection = undefined;
        this.selectedSubsection = undefined;
        this.isWidgetTypeSectionsConfigured = false;

        // this.generateTableData();
      } else {
        this.sectionDisable = true;
        this.subSectionDisable = true;
        this.tableData = [];
        this.pageTableData = [];
        this.selectedSection = undefined;
        this.selectedSubsection = undefined;
        this.generateTableData();
        this.isWidgetTypeSectionsConfigured = true;
      }
      // this.generateTableData();

      this.resetPagination();
      this.disableRightClick = true;
    } else {
      ////
    }
    //Showing selected snapshot type in main dropdown div
    for (let k = 0; k < this.snapshotTypes.length; k++) {
      if (this.snapshotTypes[k].selected == true) {
        this.typeHeader = this.snapshotTypes[k].name;
        this.sectionHeader = 'Sections';
        this.subSectionHeader = 'Sub Sections';
      }
    }
  }

  selectedSection: any;
  onSectionClick(item: any) {

    for (let i = 0; i < this.sections.length; i++) {
      // if (this.sections[i] === item && this.sections[i].selected == true) {
      //   this.sections[i].selected = false;
      // } else 
      if (this.sections[i] === item) {
        this.sections[i].selected = true;
      } else {
        this.sections[i].selected = false;
      }
    }

    //If nothing is selected in section dropdown then disbale the section and subSection
    let count = 0;
    for (let z = 0; z < this.sections.length; z++) {
      if (this.sections[z].selected == true) {
        count++;
      }
    }
    if (count == 0) {
      this.subSectionDisable = true;
      this.subSections = [];
    }

    // ------Find the selected snapshot type and section
    const selectedSnapshotType = this.snapshotTypes.find(
      (snapshotType) => snapshotType.selected
    );
    const seclectedSection = this.sections.find((section) => section.selected);
    this.selectedSection = seclectedSection;
    if (selectedSnapshotType && seclectedSection) {
      let selectedName = selectedSnapshotType.name;
      const section = seclectedSection.name;

      // if (selectedName == "Multiple Brands") {
      //   selectedName = "Multiple Brands"
      // }
      // --------Filter widgetInfo based on snapshot_type and section
      let matchingWidgets = this.widgetInfo.filter((widget: any) => {
        return (
          widget.snapshot_type === selectedName && widget.section === section
        );
      });

      ////
      // -----Extract unique subsections
      const subsectionss = matchingWidgets.map(
        (widget: any) => widget.sub_section
      );
      let uniqueSubSections = [...new Set(subsectionss)];
      ////
      uniqueSubSections = uniqueSubSections.filter((item) => item !== 'NA'); //Removing NA field

      this.subSections = [];
      for (let i = 0; i < uniqueSubSections.length; i++) {
        this.subSections.push({
          name: uniqueSubSections[i],
          value: uniqueSubSections[i],
          selected: false,
        });
      }

      // Enabling and disabling subSection div
      if (uniqueSubSections.length > 0) {
        this.subSectionDisable = false;
        this.tableData = [];
        this.pageTableData = [];
        this.selectedSubsection = undefined;
        this.resetPagination();
        this.disableRightClick = true;
        this.isWidgetTypeSectionsConfigured = false;

      } else {
        this.subSectionDisable = true;
        this.tableData = [];
        this.pageTableData = [];
        this.selectedSubsection = undefined;
        this.resetPagination();
        this.generateTableData();
        this.isWidgetTypeSectionsConfigured = true;

      }

    } else {
      //
    }
    //Showing selected section in main dropdown div
    for (let k = 0; k < this.sections.length; k++) {
      if (this.sections[k].selected == true) {
        this.sectionHeader = this.sections[k].name;
        this.subSectionHeader = 'Sub Sections';
      }
    }
  }

  selectedSubsection: any;
  onSubsectionClick(item: any) {
    for (let i = 0; i < this.subSections.length; i++) {
      // if (
      //   this.subSections[i] === item &&
      //   this.subSections[i].selected == true
      // ) {
      //   this.subSections[i].selected = false;
      // } else 
      if (this.subSections[i] === item) {
        this.subSections[i].selected = true;
        this.selectedSubsection = this.subSections[i].name;
      } else {
        this.subSections[i].selected = false;
      }
    }
    this.resetPagination();
    this.pageTableData = []
    this.tableData = [];
    this.generateTableData();
    this.isWidgetTypeSectionsConfigured = true;
    //Showing selected sub section in main dropdown div
    for (let k = 0; k < this.subSections.length; k++) {
      if (this.subSections[k].selected == true) {
        this.subSectionHeader = this.subSections[k].name;
      }
    }
  }

  //----------Handling pagination counter---------
  disableLeftClick = false;
  disableRightClick = false;
  onPageClick(side: string, page: any) {
    // 
    
    
    
    
    
    if (side == 'left') {
      if (this.pageCounter == 2) {
        this.pageCounter--;
        const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === page);
        if (pageIndex !== -1) {
          this.pageTableData[pageIndex].pagewidgetdetails = JSON.parse(JSON.stringify(this.tableData));
        } else {
          this.pageTableData.push({
            pageNumber: page,
            pagewidgetdetails: JSON.parse(JSON.stringify(this.tableData))
          });
        }
        const changedTableDataindex = this.pageTableData.findIndex((data: any) => data.pageNumber === this.pageCounter);
        if (changedTableDataindex !== -1) {
          this.tableData = this.pageTableData[changedTableDataindex].pagewidgetdetails
        }
        else {
          this.generateTableData();
        }
        this.disableLeftClick = true;
        this.disableRightClick = false;
        // return;
      } else {
        this.disableLeftClick = false;
        this.disableRightClick = false;
        this.pageCounter--;
        const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === page);
        if (pageIndex !== -1) {
          this.pageTableData[pageIndex].pagewidgetdetails = JSON.parse(JSON.stringify(this.tableData));
        } else {
          this.pageTableData.push({
            pageNumber: page,
            pagewidgetdetails: JSON.parse(JSON.stringify(this.tableData))
          });
        }
        const changedTableDataindex = this.pageTableData.findIndex((data: any) => data.pageNumber === this.pageCounter);
        if (changedTableDataindex !== -1) {
          this.tableData = this.pageTableData[changedTableDataindex].pagewidgetdetails
        }
        else {
          this.generateTableData();
        }
      }
    } else if (side == 'right') {
      if (this.pageCounter == this.filteredPage - 1) {
        const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === page);
        if (pageIndex !== -1) {
          this.pageTableData[pageIndex].pagewidgetdetails = JSON.parse(JSON.stringify(this.tableData));
        } else {
          this.pageTableData.push({
            pageNumber: page,
            pagewidgetdetails: JSON.parse(JSON.stringify(this.tableData))
          });
        }
        this.pageCounter++;
        this.disableRightClick = true;
        this.disableLeftClick = false;
        const changedTableDataindex = this.pageTableData.findIndex((data: any) => data.pageNumber === this.pageCounter);
        if (changedTableDataindex !== -1) {
          this.tableData = this.pageTableData[changedTableDataindex].pagewidgetdetails
        }
        else {
          this.generateTableData();
        }
        // return;
      } else {
        this.pageCounter++;
        const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === page);
        if (pageIndex !== -1) {
          this.pageTableData[pageIndex].pagewidgetdetails = JSON.parse(JSON.stringify(this.tableData));
        } else {
          this.pageTableData.push({
            pageNumber: page,
            pagewidgetdetails: JSON.parse(JSON.stringify(this.tableData))
          });
        }
        const changedTableDataindex = this.pageTableData.findIndex((data: any) => data.pageNumber === this.pageCounter);
        if (changedTableDataindex !== -1) {
          this.tableData = this.pageTableData[changedTableDataindex].pagewidgetdetails
        }
        else {
          this.generateTableData();
        }
        this.disableLeftClick = false;
        this.disableRightClick = false;
      }
    }
    
  }
  isPageReset: boolean = false;
  filteredPage: number = 1;
  generateTableData() {
    const selectedSnapshotTypeObj = this.snapshotTypes.find(
      (snapshotType) => snapshotType.selected
    );
    const selectedSnapshotType = selectedSnapshotTypeObj
      ? selectedSnapshotTypeObj.name
      : null;

    const selectedSectionObj = this.sections.find(
      (section) => section.selected
    );
    const selectedSection = selectedSectionObj ? selectedSectionObj.name : null;

    const selectedSubSectionObj = this.subSections.find(
      (subSection) => subSection.selected
    );
    const selectedSubSection = selectedSubSectionObj
      ? selectedSubSectionObj.name
      : null;

    let pageWiseFullData = this.groupedByPage[this.pageCounter - 1];


    // ------------------Code to handle selectionwise page number ----------------------
    this.filteredPage = 1;

    for (let i = (this.groupedByPage.length - 1); i >= 0; i--) {
      let index;
      let x;
      // // ;
      if (selectedSnapshotType != null && selectedSection != null && selectedSubSection != null) {
        x = this.groupedByPage[i].items.filter(
          (item: any) =>
            item.snapshot_type === selectedSnapshotType &&
            item.section === selectedSection &&
            item.sub_section === selectedSubSection
        );
        if (x.length > 0) {
          this.filteredPage = (i + 1);
          break;
        }
      }
      else if (selectedSnapshotType != null && selectedSection != null && selectedSubSection == null) {
        x = this.groupedByPage[i].items.filter(
          (item: any) =>
            item.snapshot_type === selectedSnapshotType &&
            item.section === selectedSection
        );
        if (x.length > 0) {
          this.filteredPage = (i + 1);
          break;
        }
      }
      else if (selectedSnapshotType != null && selectedSection == null && selectedSubSection == null) {
        x = this.groupedByPage[i].items.filter(
          (item: any) => item.snapshot_type === selectedSnapshotType
        );
        if (x.length > 0) {
          this.filteredPage = (i + 1);
          break;
        }
      } else {
        index = i;
        // ;
      }
    }
    //If selection contains only one page then make rightPagination clack disable
    if (this.filteredPage == 1) {
      this.disableRightClick = true;
    }

    // -------------------------------------
    // ;









    
    
    
    
    
    
    
    
    let displayItems = [];
    if (
      selectedSnapshotType != null &&
      selectedSection != null &&
      selectedSubSection != null
    ) {
      displayItems = pageWiseFullData.items.filter(
        (item: any) =>
          item.snapshot_type === selectedSnapshotType &&
          item.section === selectedSection &&
          item.sub_section === selectedSubSection
      );
    } else if (
      selectedSnapshotType != null &&
      selectedSection != null &&
      selectedSubSection == null
    ) {
      displayItems = pageWiseFullData.items.filter(
        (item: any) =>
          item.snapshot_type === selectedSnapshotType &&
          item.section === selectedSection
      );
    } else if (
      selectedSnapshotType != null &&
      selectedSection == null &&
      selectedSubSection == null
    ) {
      displayItems = pageWiseFullData.items.filter(
        (item: any) => item.snapshot_type === selectedSnapshotType
      );
    } else {
      // pageWiseFullData.items=[]
    }
    const selectedSnapshotType1 = this.selectedSnapshotType == undefined ? "NA" : this.selectedSnapshotType.name;
    const selectedSection1 = this.selectedSection == undefined ? "NA" : this.selectedSection.name;
    const selectedSubSection1 = this.selectedSubsection == undefined ? "NA" : this.selectedSubsection.name;
    let edata = JSON.parse(JSON.stringify(this.existingData))
    const exdata = edata.find((d: any) => d.sections == selectedSection1 && d.snapshotType == selectedSnapshotType1 && d.subsection == selectedSubSection1);
    
    if (exdata) {
      this.isExisting = true;
    }
    else {
      this.isExisting = false;
    }
    
    const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === this.pageCounter);
    
    
    if (pageIndex !== -1 && !this.isPageReset && this.saveChanges) {
      this.tableData = this.pageTableData[pageIndex].pagewidgetdetails;
      
    }
    else {
      this.tableData = [];
      for (let i = 0; i < displayItems.length; i++) {
        let product = displayItems[i].product;
        let template = displayItems[i].template;
        let section = displayItems[i].section;
        let maxselect = displayItems[i].max_limit;
        let submetric =
          displayItems[i].sub_widget_name == 'NA'
            ? [displayItems[i].sub_widget_name] // Wrap the single string in an array
            : this.widgetInfo
              .filter(
                (widget: any) =>
                  widget.product == product &&
                  widget.template == template &&
                  widget.section == section &&
                  widget.sub_widget_name != 'NA'
              )
              .map((widget: any) => widget.sub_widget_name);
        let metricselect = displayItems[i].metric_select;
        submetric = submetric.map((i: any) => {
          return {
            subWidgetName: i,
            isDropdown: false,
            option: "Not Selected",
            max_selection: maxselect,
            filteredoptions:
              metricselect == 1 ||
                metricselect == 2
                ? JSON.parse(JSON.stringify(this.metrics))
                : JSON.parse(JSON.stringify(this.groupedData)),
          };
        });

        
        this.tableData.push({
          sort: displayItems[i].sort,
          widgetNumber: displayItems[i].widget_no,
          widgetName: displayItems[i].widget_name,
          visualization: displayItems[i].visualization_list,
          metric: {
            metric_select: displayItems[i].metric_select,
            option: 'Multiple',
            isDropdownOpen: false,
            sublist:
              displayItems[i].sub_widget_name != 'NA'
                ? submetric
                : [
                  {
                    subWidgetName: displayItems[i].sub_widget_name,
                    isDropdown: false,
                    option: "Not Selected",
                    maxselect: displayItems[i].max_limit,
                    filteredoptions:
                      metricselect == 1 ||
                        metricselect == 2 || this.metricGroupLength == 0
                        ? JSON.parse(JSON.stringify(this.metrics))
                        : JSON.parse(JSON.stringify(this.groupedData)),
                  },
                ],
            metricselect1and2:
              displayItems[i].metric_select == 1 ||
                displayItems[i].metric_select == 2 || this.metricGroupLength == 0
                ? JSON.parse(JSON.stringify(this.metrics))
                : [],
            metricselect3: JSON.parse(JSON.stringify(this.groupedData)),
            filteredoptions:
              displayItems[i].metric_select == 1 ||
                displayItems[i].metric_select == 2 || this.metricGroupLength == 0
                ? JSON.parse(JSON.stringify(this.metrics))
                : JSON.parse(JSON.stringify(this.groupedData)),
          },
          trend: false,
          trendDiv: false,
          infoIcon: '',
        });


      }

      this.tableData.sort((a, b) => a.widgetNumber - b.widgetNumber);

      if (this.isExisting) {
        if (exdata) {
          const pageDetails = exdata.widgetPageConfiguration.find((page: any) => page.pageNumber == this.pageCounter)

          if (pageDetails) {
            this.tableData.forEach((t: any) => {
              const row = pageDetails.pagewidgetdetails.find((prow: any) => prow.widgetNumber == t.widgetNumber);

              if (row) {
                t.widgetName = row.widgetName;
                t.infoIcon = row.infoIcon;
                t.trend = row.trend;
                t.trendDiv = row.trendDiv;
                t.metric.sublist.forEach((s: any) => {
                  const sub = row.metric.find((sub1: any) => sub1.submetricName == s.subWidgetName);

                  if (sub) {
                    t.metric.sublist.forEach((s1: any) => s1.isDropdown = false)
                    s.isDropdown = true;
                    if (t.metric.metric_select != 3 || this.metricGroupLength == 0) {
                      s.filteredoptions.forEach((item: any) => {
                        const selectedoption = sub.metricSelected.metrics.find((selectedoption1: any) => selectedoption1.metricName == item.option);
                        
                        if (selectedoption) {
                          s.option = item.option;
                          item.isSelected = true;
                          item.selectorder = selectedoption.selectorder;
                          this.addOrUpdateMetric(t, item, this.pageCounter);
                        }
                      })
                      if (sub.metricSelected.metrics.length > 1) {
                        s.option = "Multiple";
                      }
                      if (sub.metricSelected.metrics.length = 0) {
                        s.option = "Not Selected";
                      }
                      

                      const maxSelectOrder = s.filteredoptions.reduce(
                        (max: any, item: any) => {
                          return item.selectorder > max ? item.selectorder : max;
                        },
                        -Infinity
                      );
                      if (maxSelectOrder >= s.maxselect) {
                        s.maxlimitreached = true;
                        
                      }
                      else {
                        s.maxlimitreached = false;
                      }
                    }
                    else {
                      s.filteredoptions.forEach((item: any) => {
                        
                        if (item.option == "METRICS") {
                          item.Level2.forEach((il2: any) => {
                            const selectedoption = sub.metricSelected.metrics.find((selectedoption1: any) => selectedoption1.metricName == il2.option);

                            if (selectedoption) {
                              il2.isSelected = true;
                              il2.selectorder = selectedoption.selectorder;
                              this.addOrUpdateMetric3(t, item, il2, this.pageCounter);
                            }
                          })
                        }
                        if (item.option == "METRIC GROUP") {
                          item.Level2?.forEach((il2: any) => {
                            const selectedoption = sub.metricSelected.groups;
                            if (il2.option == selectedoption) {
                              il2.isSelected = true;
                              this.addOrUpdateMetric3(t, item, il2, this.pageCounter);
                              // item.selectorder = selectedoption.selectorder;
                            }
                          })
                        }

                      })
                      if (sub.metricSelected.metrics.length > 1 || (sub.metricSelected.metrics.length == 1 && sub.metricSelected.groups != "")) {
                        s.option = "Multiple";
                      }
                      else if (sub.metricSelected.groups != "" && sub.metricSelected.metrics.length < 1) {
                        s.option = sub.metricSelected.groups;
                      }
                      else if (sub.metricSelected.metrics.length == 1 && sub.metricSelected.groups == "") {
                        s.option = sub.metricSelected.metrics[0].metricName;
                      }
                      else {
                        s.option = "Not selected";
                      }
                      const metricsLength = this.metricCheckedList
                        .filter((m: any) => m.widgetNo === row.widgetNumber && m.page == this.pageCounter)
                        .flatMap((m: any) => m.metric)
                        .filter((met: any) => met.submetricname === sub.subWidgetName)
                        .reduce((length: number, met: any) => length + met.metricselected.metrics.length, 0);

                      if (metricsLength >= s.maxselect) {
                        s.maxlimitreached = true;
                      }
                      else {
                        s.maxlimitreached = false;
                      }
                    }
                  }
                  // else{
                  //   s.isDropdown = true;
                  // }
                })
              }
            })
            
            
            const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === this.pageCounter);
            if (pageIndex !== -1) {
              this.pageTableData[pageIndex].pagewidgetdetails = JSON.parse(JSON.stringify(this.tableData));
            } else {
              this.pageTableData.push({
                pageNumber: this.pageCounter,
                pagewidgetdetails: JSON.parse(JSON.stringify(this.tableData))
              });
            }
          }
        }
      }
      
      //  selectedSnapshotType
    }

    // this.tableData = []
    // for (let i = 0; i < displayItems.length; i++) {
    //   this.tableData.push({ widgetNumber: displayItems[i].widget_no, widgetName:displayItems[i].widget_name, visualization: displayItems[i].visualization_list, metric: 'Row 1 Col 4', infoIcon: '' })
    // }
  }

  otherPagesTabledata: any = []
  loadOtherPagesData() {

    
    for (let i = 0; i < this.groupedByPage.length; i++) {
      const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === i + 1);
      if (pageIndex == -1) {
        const selectedSnapshotTypeObj = this.snapshotTypes.find(
          (snapshotType) => snapshotType.selected
        );
        const selectedSnapshotType = selectedSnapshotTypeObj
          ? selectedSnapshotTypeObj.name
          : null;

        const selectedSectionObj = this.sections.find(
          (section) => section.selected
        );
        const selectedSection = selectedSectionObj ? selectedSectionObj.name : null;

        const selectedSubSectionObj = this.subSections.find(
          (subSection) => subSection.selected
        );
        const selectedSubSection = selectedSubSectionObj
          ? selectedSubSectionObj.name
          : null;
        let pageWiseFullData = this.groupedByPage[i];
        let displayItems = [];
        if (
          selectedSnapshotType != null &&
          selectedSection != null &&
          selectedSubSection != null
        ) {
          displayItems = pageWiseFullData.items.filter(
            (item: any) =>
              item.snapshot_type === selectedSnapshotType &&
              item.section === selectedSection &&
              item.sub_section === selectedSubSection
          );
        } else if (
          selectedSnapshotType != null &&
          selectedSection != null &&
          selectedSubSection == null
        ) {
          displayItems = pageWiseFullData.items.filter(
            (item: any) =>
              item.snapshot_type === selectedSnapshotType &&
              item.section === selectedSection
          );
        } else if (
          selectedSnapshotType != null &&
          selectedSection == null &&
          selectedSubSection == null
        ) {
          displayItems = pageWiseFullData.items.filter(
            (item: any) => item.snapshot_type === selectedSnapshotType
          );
        } else {
          // pageWiseFullData.items=[]
        }
        const selectedSnapshotType1 = this.selectedSnapshotType == undefined ? "NA" : this.selectedSnapshotType.name;
        const selectedSection1 = this.selectedSection == undefined ? "NA" : this.selectedSection.name;
        const selectedSubSection1 = this.selectedSubsection == undefined ? "NA" : this.selectedSubsection.name;
        let edata = JSON.parse(JSON.stringify(this.existingData))
        const exdata = edata.find((d: any) => d.sections == selectedSection1 && d.snapshotType == selectedSnapshotType1 && d.subsection == selectedSubSection1);
        
        if (exdata) {
          this.isExisting = true;
        }
        else {
          this.isExisting = false;
        }
        // const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === this.pageCounter);
        // 
        // 
        // if (pageIndex !== -1 && !this.isPageReset) {
        //   this.tableData = this.pageTableData[pageIndex].pagewidgetdetails;
        //   
        // }
        // else {
        this.otherPagesTabledata = []
        for (let i = 0; i < displayItems.length; i++) {
          let product = displayItems[i].product;
          let template = displayItems[i].template;
          let section = displayItems[i].section;
          let maxselect = displayItems[i].max_limit;
          let submetric =
            displayItems[i].sub_widget_name == 'NA'
              ? [displayItems[i].sub_widget_name] // Wrap the single string in an array
              : this.widgetInfo
                .filter(
                  (widget: any) =>
                    widget.product == product &&
                    widget.template == template &&
                    widget.section == section &&
                    widget.sub_widget_name != 'NA'
                )
                .map((widget: any) => widget.sub_widget_name);
          let metricselect = displayItems[i].metric_select;
          submetric = submetric.map((i: any) => {
            return {
              subWidgetName: i,
              isDropdown: false,
              option: "Not Selected",
              max_selection: maxselect,
              filteredoptions:
                metricselect == 1 ||
                  metricselect == 2
                  ? JSON.parse(JSON.stringify(this.metrics))
                  : JSON.parse(JSON.stringify(this.groupedData)),
            };
          });

          
          this.otherPagesTabledata.push({
            widgetNumber: displayItems[i].widget_no,
            widgetName: displayItems[i].widget_name,
            visualization: displayItems[i].visualization_list,
            metric: {
              metric_select: displayItems[i].metric_select,
              option: 'Multiple',
              isDropdownOpen: false,
              sublist:
                displayItems[i].sub_widget_name != 'NA'
                  ? submetric
                  : [
                    {
                      subWidgetName: displayItems[i].sub_widget_name,
                      isDropdown: false,
                      option: "Not Selected",
                      maxselect: displayItems[i].max_limit,
                      filteredoptions:
                        metricselect == 1 ||
                          metricselect == 2 || this.metricGroupLength == 0
                          ? JSON.parse(JSON.stringify(this.metrics))
                          : JSON.parse(JSON.stringify(this.groupedData)),
                    },
                  ],
              metricselect1and2:
                displayItems[i].metric_select == 1 ||
                  displayItems[i].metric_select == 2 || this.metricGroupLength == 0
                  ? JSON.parse(JSON.stringify(this.metrics))
                  : [],
              metricselect3: JSON.parse(JSON.stringify(this.groupedData)),
              filteredoptions:
                displayItems[i].metric_select == 1 ||
                  displayItems[i].metric_select == 2 || this.metricGroupLength == 0
                  ? JSON.parse(JSON.stringify(this.metrics))
                  : JSON.parse(JSON.stringify(this.groupedData)),
            },
            trend: false,
            trendDiv: false,
            infoIcon: '',
          });
          ;
        }
        
        if (this.isExisting) {
          
          
          
          
          
          if (exdata) {
            
            const pageDetails = exdata.widgetPageConfiguration.find((page: any) => page.pageNumber == i + 1)
            if (pageDetails) {
              
              
              // this.tableData=pageDetails.pagewidgetdetails;
              this.otherPagesTabledata.forEach((t: any) => {
                const row = pageDetails.pagewidgetdetails.find((prow: any) => prow.widgetNumber == t.widgetNumber);
                if (row) {
                  t.widgetName = row.widgetName;
                  t.trend = row.trend;
                  t.trendDiv = row.trendDiv;
                  t.infoIcon = row.infoIcon;
                  t.metric.sublist.forEach((s: any) => {
                    const sub = row.metric.find((sub1: any) => sub1.submetricName == s.subWidgetName);
                    // 
                    // 
                    if (sub) {
                      s.isDropdown = true;
                      if (t.metric.metric_select != 3 || this.metricGroupLength == 0) {
                        // 
                        // 
                        // 
                        // 
                        s.filteredoptions.forEach((item: any) => {
                          const selectedoption = sub.metricSelected.metrics.find((selectedoption1: any) => selectedoption1.metricName == item.option);
                          
                          if (selectedoption) {
                            s.option = item.option;
                            item.isSelected = true;
                            item.selectorder = selectedoption.selectorder;
                            this.addOrUpdateMetric(t, item, i + 1);
                          }
                        })
                        if (sub.metricSelected.metrics.length > 1) {
                          s.option = "Multiple";
                        }
                        if (sub.metricSelected.metrics.length = 0) {
                          s.option = "Not Selected";
                        }
                      }
                      else {
                        s.filteredoptions.forEach((item: any) => {
                          
                          if (item.option == "METRICS") {
                            item.Level2.forEach((il2: any) => {
                              const selectedoption = sub.metricSelected.metrics.find((selectedoption1: any) => selectedoption1.metricName == il2.option);
                              if (selectedoption) {
                                il2.isSelected = true;
                                item.selectorder = selectedoption.selectorder;
                                this.addOrUpdateMetric3(t, item, il2, i + 1);
                              }
                            })
                          }
                          if (item.option == "METRIC GROUP") {
                            item.Level2.forEach((il2: any) => {
                              const selectedoption = sub.metricSelected.groups;
                              if (il2.option == selectedoption) {
                                il2.isSelected = true;
                                this.addOrUpdateMetric3(t, item, il2, i + 1);
                                // item.selectorder = selectedoption.selectorder;
                              }
                            })
                          }

                        })
                        if (sub.metricSelected.metrics.length > 1 || (sub.metricSelected.metrics.length == 1 && sub.metricSelected.groups != "")) {
                          s.option = "Multiple";
                        }
                        else if (sub.metricSelected.groups != "" && sub.metricSelected.metrics.length < 1) {
                          s.option = sub.metricSelected.groups;
                        }
                        else {
                          s.option = "Not selected";
                        }
                      }
                    }
                  })
                }
              })
              
              
              const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === i + 1);
              if (pageIndex !== -1) {
                this.pageTableData[pageIndex].pagewidgetdetails = JSON.parse(JSON.stringify(this.otherPagesTabledata));
              } else {
                this.pageTableData.push({
                  pageNumber: i + 1,
                  pagewidgetdetails: JSON.parse(JSON.stringify(this.otherPagesTabledata))
                });
              }
            }
          }
        }
        
        // }
      }
    }
  }


  filterOptions(metric: any, metricdata: any, metric_select: any) {
    const searchLower = this.searchmetric.toLowerCase(); 
    
    let foptions = metricdata;
    let metric1 = JSON.parse(JSON.stringify(metric));
    // 
    foptions.forEach((f: any) => {
      if (metric_select == 1) {
        f.isSelected = false;
        f.selectorder = 0;
      }
      let sfoption = metric1.filteredoptions.find((sf: any) => sf.option == f.option);
      if (sfoption) {
        f.isSelected = sfoption.isSelected;
        f.selectorder = sfoption.selectorder;
      }
    })
    if (metric_select < 3) {
      metric.filteredoptions = foptions.filter((item: any) =>
        item.option.toLowerCase().includes(searchLower)
      );
    } else {
      metric.filteredoptions = foptions.filter((item: any) => {
        if(item.Level2){
          // If Level2 exists, filter within Level2
          return item.Level2.filter((lev2: any) =>
            lev2.option.toLowerCase().includes(searchLower)
          )
        }
        else{
         return item.option.toLowerCase().includes(searchLower);
        }
    });
    }
  }

  filterOptions2(metric: any, metricdata: any, metric_select: any, level1name: any) {
    // 
    // 
    // 
    const searchLower = this.searchmetric.toLowerCase();
    // 
    if (metric_select < 3) {
      metric.filteredoptions = metricdata.filter((item: any) =>
        item.option.toLowerCase().includes(searchLower)
      );
    } else {
      let foptions = metricdata.find((md: any) => md.option == level1name)?.Level2;
      let metric1 = JSON.parse(JSON.stringify(metric.filteredoptions.find((mdd: any) => mdd.option == level1name)?.Level2));
      // 
      foptions.forEach((f: any) => {
        let sfoption = metric1.find((sf: any) => sf.option == f.option);
        if (sfoption) {
          f.isSelected = sfoption.isSelected;
          f.selectorder = sfoption.selectorder;
        }
        if (level1name == "METRIC GROUP" && sfoption?.isSelected && sfoption) {
          foptions.forEach((f1: any) => {
            if (f1.option !== sfoption.option) {
              f1.isSelected = false;
              f1.selectorder = 0;
            }
          })

        }
      })
      const sublevel = metric.filteredoptions.find((i: any) => i.option == level1name);
      const sublevelmetricdata = metricdata.find((i: any) => i.option == level1name)
      // 
      sublevel.Level2 = foptions.map((item: any) => { if (item.option.toLowerCase().includes(searchLower)) { return item; } }).filter((item: any) => item !== undefined)

      //  => {
      //   item.option.toLowerCase().includes('brand')
      // }))

      
    }
  }


  // togglemetricDropdown(row: any, submetric: any, submetriclist: any, selectElement: any) {
  //   
  //   
  //   
  //   
  //   
  //   
  //   this.searchmetric = '';
  //   this.tableData.forEach((r: any) => {
  //     if (r == row) {
  //       r.metric.isDropdownOpen = true;
  //       r.metric.sublist.forEach((s: any) => {
  //         if (s == submetric) {
  //           
  //           
  //           let foptions = JSON.parse(JSON.stringify(row.metric.filteredoptions));
  //           foptions.forEach((f: any) => {
  //             let sfoptions = submetric.filteredoptions.find((sf: any) => f.option == sf.option);
  //             
  //             if (sfoptions) {
  //               f.isSelected = sfoptions.isSelected
  //               f.selectorder = sfoptions.selectorder
  //             }
  //           })
  //           submetric.filteredoptions = foptions
  //           s.isDropdown = !s.isDropdown;
  //           this.calculateDropdownPosition(selectElement, row.metric);
  //         }
  //         else {
  //           s.isDropdown = false;
  //         }
  //       })
  //     } else {
  //       r.metric.isDropdownOpen = false;
  //     }
  //   });
  // }

  togglemetricDropdown(row: any, submetric: any, submetriclist: any, selectElement: any) {
    
    
    
    
    
    
    let m1: any = []
    if (row.metric.metric_select == 3 && this.metricGroupLength != 0) {
      //  m1=row.metric.filteredoptions;
      // submetric.filteredoptions=row.metric.metricselect3;
    }
    this.searchmetric = '';
    this.tableData.forEach((r: any) => {
      if (r == row) {
        r.metric.isDropdownOpen = true;
        r.metric.sublist.forEach((s: any) => {
          if (s == submetric) {
            
            

            let foptions = row.metric.metric_select != 3 || this.metricGroupLength == 0 ? row.metric.filteredoptions : row.metric.filteredoptions[0].Level2.length > row.metric.metricselect3[0].Level2.length ? JSON.parse(JSON.stringify(row.metric.filteredoptions)) : JSON.parse(JSON.stringify(row.metric.metricselect3));
            // Add initialOrder to track the original positions, only if it's not already set
            foptions.forEach((option: any, index: number) => {
              if (option.initialOrder === undefined) {
                  option.initialOrder = index;
              }
          });
              //sorting based on selected order
              if(row.metric.metric_select !=3){
          
                this.sortBySelectOrder(foptions);

          }
      
              //end
            foptions.forEach((f:any)=>{
              let sfoptions=submetric.filteredoptions.find((sf:any)=>f.option==sf.option);
              
              if(sfoptions){
                // sfoptions.isSelected=f.isSelected
                if (row.metric.metric_select != 3 || this.metricGroupLength == 0) {
                  f.isSelected = sfoptions.isSelected;
                  f.selectorder = sfoptions.selectorder;
                }
                else{
                  sfoptions.isDropdownOpen=false;
                  f.Level2.forEach((l2:any)=>{
                    let sfl2option=sfoptions.Level2.find((s:any)=>s.option==l2.option);
                    if(sfl2option){
                      l2.isSelected=sfl2option.isSelected;
                      l2.selectorder=sfl2option.selectorder;
                    }
                  })
                }
              }
            })
            if(row.metric.metric_select == 3){
    
              foptions.forEach((item:any) => {
                this.sortBySelectOrder(item.Level2);
       
            });
            }
            submetric.filteredoptions=foptions
            s.isDropdown = !s.isDropdown;
            this.calculateDropdownPosition(selectElement, row.metric);
          }
          else {
            s.isDropdown = false;
          }
        })
      } else {
        r.metric.isDropdownOpen = false;
      }
    });
  }

   sortBySelectOrder(arr: any[]): void {
    arr?.sort((a: any, b: any) => {
        if (a.selectorder === 0 && b.selectorder !== 0) {
            return 1; // Keep 'a' in the same place
        } else if (a.selectorder !== 0 && b.selectorder === 0) {
            return -1; // Move 'b' to after 'a'
        } else if (a.selectorder === 0 && b.selectorder === 0) {
            // If both have selectorder === 0, revert to initial order
            return a.initialOrder - b.initialOrder;
        } else {
            return a.selectorder - b.selectorder; // Sort non-zero selectorder in ascending order
        }
    });
}

  togglemetriclev1Dropdown(row: any, lev1: any, submetricname: any) {
    // 
    this.searchmetric = "";
    let isDropdownToggled = false;
    this.tableData.forEach((r: any) => {
      // Flag to track if the dropdown state has been toggled
      // 
      if (row == r) {
        
        
        
        
        
        const sub = row.metric.sublist.find((s: any) => s.subWidgetName == submetricname);
        if (sub) {
          const sub1 = sub.filteredoptions.find((f: any) => f.option == lev1.option)
          sub1.isDropdownOpen = !sub1.isDropdownOpen;
          sub.filteredoptions.forEach((s: any) => {
            if (s.option != lev1.option) {
              s.isDropdownOpen = false;
            }
          });
        }

        
      }

    });

  }

  convertPxToPercentage(px: number, parentPx: number): number {
    return (px / parentPx) * 100;
  }

  getViewportWidth(): number {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }

  calculateDropdownPosition(selectElement: HTMLElement, item: any) {
    this.cdr.detectChanges();
    // 
    // 
    // 
    const rect = selectElement.getBoundingClientRect();
    const dropdownHeight = item.metric_select != 3 || this.metricGroupLength == 0 ? 241 : 110; // Adjust this based on your dropdown height
    let spaceAbove = rect?.top;
    spaceAbove = (spaceAbove / window.innerHeight) * 100;
    const spaceBelow = window.innerHeight - rect?.bottom;
    // 
    // Set the dropdown position based on available space
    // 
    const optionsElement = this.optionsElements.toArray()[0];
    const multiplesublist = item.sublist.length > 1 ? true : false;
    if (optionsElement) {
      if (spaceBelow > dropdownHeight) {
        optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - 0.347 * rect.left}px`;
      }
      else {
        // If neither space is sufficient, open in the available space below
        if (!multiplesublist) {
          optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - dropdownHeight - 0.385 * rect.left}px`;
        }
        else {
          optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - dropdownHeight - 0.32 * rect.left}px`;
          optionsElement.nativeElement.style.width = `24%`;
        }

      }


      var zoomLevel = Math.round(window.devicePixelRatio * 100);
      // var screenWidth = window.screen.width;
      // var screenHeight = window.screen.height;
      if (zoomLevel == 125) {
        if (spaceBelow > dropdownHeight) {
          if (!multiplesublist) {
            optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - 0.359 * rect.left}px`;
          }
          else {
            optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - dropdownHeight - 0.345 * rect.left}px`;
            optionsElement.nativeElement.style.width = `24%`;
          }
        }
        else {
          if (!multiplesublist) {
            optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - dropdownHeight - 0.415 * rect.left}px`;
          }
          else {
            optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - dropdownHeight - 0.345 * rect.left}px`;
            optionsElement.nativeElement.style.width = `24%`;
          }
        }
      }

      if (zoomLevel == 100) {
        if (spaceBelow > dropdownHeight) {
          if (!multiplesublist) {
            optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - 0.37 * rect.left}px`;
          }
          else {
            optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - dropdownHeight - 0.345 * rect.left}px`;
            optionsElement.nativeElement.style.width = `24%`;
          }
        }
        else {
          if (!multiplesublist) {
            optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - dropdownHeight - 0.415 * rect.left}px`;
          }
          else {
            optionsElement.nativeElement.style.top = `${rect.bottom + window.scrollY - dropdownHeight - 0.345 * rect.left}px`;
            optionsElement.nativeElement.style.width = `24%`;
          }
        }
      }


      optionsElement.nativeElement.style.left = `${rect.left + window.scrollX}px`;
    }

  }

  onResetClick() {
    this.isWidgetTypeSectionsConfigured = false;
    this.isPageReset = true;
    this.snapshotTypes = [];
    this.sections = [];
    this.subSections = [];
    this.typeHeader = 'Snapshot Types';
    this.sectionHeader = 'Sections';
    this.subSectionHeader = 'Sub Sections';
    this.metricCheckedList = [];
    //this.generateTableData();
    this.resetPagination();
    this.sectionDisable = true;
    this.subSectionDisable = true;
    this.widgetDatacall();
    this.tableData = [];
    setTimeout(() => {
      this.tableClicked = false;
    }, 1);

  }

  resetPagination() {
    this.pageCounter = 1;
    this.disableLeftClick = true;
    this.disableRightClick = false;
  }
  // -----------------MAin table-------------------
  tableData: any[] = [];
  // tableData = [
  //   { widgetNumber: '1', widgetName: 'Row 1 Col 2', visualization: 'Row 1 Col 3', metric: 'Row 1 Col 4', infoIcon: '' },
  //   { widgetNumber: '2', widgetName: 'Row 2 Col 2', visualization: 'Row 2 Col 3', metric: 'Row 2 Col 4', infoIcon: '' },
  //   { widgetNumber: '3', widgetName: 'Row 3 Col 2', visualization: 'Row 3 Col 3', metric: 'Row 3 Col 4', infoIcon: '' },
  //   { widgetNumber: '4', widgetName: 'Row 4 Col 2', visualization: 'Row 4 Col 3', metric: 'Row 4 Col 4', infoIcon: '' },
  //   { widgetNumber: '5', widgetName: 'Row 5 Col 2', visualization: 'Row 5 Col 3', metric: 'Row 5 Col 4', infoIcon: '' },
  //   { widgetNumber: '6', widgetName: 'Row 6 Col 2', visualization: 'Row 6 Col 3', metric: 'Row 6 Col 4', infoIcon: '' }
  // ];
  trendEnablingDisablingLogicFun(clonedArray: any, clonedReference: any) {
    let allSame = false;
    clonedArray.forEach((item: any) => {
      if (item.option === clonedReference.option) {
        if (clonedReference.isSelected && item.isSelected) {
          // If referenceObject isSelected is true and array object isSelected is also true
          item.isSelected = false;
        } else if (!clonedReference.isSelected && !item.isSelected) {
          // If referenceObject isSelected is false and array object isSelected is also false
          item.isSelected = true;
        }
      }
    });

    //code to find whether trendFlag is same or not from list of selected item
    let x = clonedArray.filter((item: any) => item.isSelected == true)
    const filteredArray = this.uniqueMetricsWithTrend.filter((item: any) =>
      x.some((lev1Item: any) => lev1Item.option === item.WidgetMapping_Variables)
    );  
    const firstTrendFlag = filteredArray[0]?.Trend_Flag; // Get the Trend_Flag of the first object
    allSame = filteredArray.every((item: any) => item.Trend_Flag === firstTrendFlag);
    if (filteredArray.length == 0) {
      allSame = false;
    }
    return allSame;
  }
  metricCheckedList: any = [];
  metriccheckboxchecked(event: any, r: any, lev: any, sublist: any, lev1: any, page: any) {
    // // 
    // // 
    var clonedlev = _.cloneDeep(lev);
    var clonedlev1 = _.cloneDeep(lev1);
    var allSame = false;
    //when metriclist and metric group both present
    if (typeof lev1 === 'object' && lev1 !== null && lev1.hasOwnProperty('option')) {
      if (lev1.type == "radio") {
        allSame = true;
      }
      else if (lev1.option == "METRICS" && lev1.type == "checkbox") {
        var clonedlev2 = _.cloneDeep(lev1.Level2);
        allSame = this.trendEnablingDisablingLogicFun(clonedlev2, clonedlev);
      }
    }
    //when metriclist is only present
    else {
      //for radio metric select
      if (r.metric.metric_select == 1) {
        allSame = true;
      }
      //for checkbox metric select
      else {
        allSame = this.trendEnablingDisablingLogicFun(clonedlev1, clonedlev);
      }
    }
    this.tableData.forEach((row: any) => {
      if (row == r && row.widgetNumber == r.widgetNumber) {
        row.trendDiv = allSame;
        if (allSame == false) {
          row.trend = allSame;
        }

        row.metric.sublist.forEach((sub: any) => {
          if (sub == sublist) {
            // 
            // 
            for (let i = 0; i < sub.filteredoptions.length; i++) {
              let item = sub.filteredoptions[i];
              let item1 = r.metric.filteredoptions[i];
              if (row.metric.metric_select == 1) {
                // ;
                if (item == lev) {
                  item.isSelected = event.target.checked;
                  this.metricCheckedList = this.metricCheckedList.map((m: any) => {
                    if (m.metric_select === 1) {
                      m.metric = m.metric.filter((metricItem: any) => metricItem.submetricname !== sub.subWidgetName);
                    }
                    return m;
                  }).filter((m: any) => m.metric.length > 0 || m.metric_select !== 1);                  // this.metricCheckedList.push({
                  //   widgetNo: r.widgetNumber,
                  //   metric: {
                  //     submetricname: r.metric.sublist.filter((i: any) => i.isDropdown).map((i: any) => i.subWidgetName)[0],
                  //     metricselected: {
                  //       Level1: [{ option: item.option, level2: [] }]
                  //     }
                  //   },
                  //   metric_select: 1
                  // });
                  if (event.target.checked) {
                    this.addOrUpdateMetric(r, item, page);
                    sublist.option = item.option;
                  }
                } else {
                  item.isSelected = false;
                  item1.isSelected = false;
                }
                // 
              }
              if (row.metric.metric_select == 2 || this.metricGroupLength == 0) {
                                const metricRow = this.metricCheckedList.find((m: any) => m.page == this.pageCounter && m.widgetNo == r.widgetNumber);
                let maxSelectOrder = item.selectorder;
                if (metricRow) {
                  const sublistOfmetric = metricRow.metric.find((s: any) => sub.subWidgetName == s.submetricname);
                  if (sublistOfmetric) {
                    maxSelectOrder = sublistOfmetric?.metricselected.metrics.reduce((max: any, item: any) => {
                      return item.selectorder > max ? item.selectorder : max;
                    },
                      -Infinity);
                  }
                }

                const maxSelectOrder1 = sub.filteredoptions.reduce(
                  (max: any, item: any) => {
                    return item.selectorder > max ? item.selectorder : max;
                  },
                  -Infinity
                );
                if (item == lev) {
                  ;
                  item.isSelected = event.target.checked;
                  const submetricname = r.metric.sublist.filter((i: any) => i.isDropdown).map((i: any) => i.subWidgetName)[0];
                  if (event.target.checked) {
                    item.selectorder = maxSelectOrder + 1;
                    this.addOrUpdateMetric(r, item, page);
                    const metricSelectedLength = this.metricCheckedList
                      .filter((m: any) => m.widgetNo === r.widgetNumber)
                      .flatMap((m: any) => m.metric)
                      .filter((met: any) => met.submetricname === sub.subWidgetName)
                      .reduce((length: number, met: any) => length + met.metricselected.metrics.length, 0);
                    sublist.option = metricSelectedLength < 1 ? "Not Selected" : (metricSelectedLength == 1 ? item.option : "Multiple");
                    if (metricSelectedLength >= sub.maxselect) {
                      sub.maxlimitreached = true;
                      // 
                    }
                    else {
                      sub.maxlimitreached = false;
                    }
                  } else {
                    sublist.filteredoptions.forEach((it: any) => {
                      if (it.selectorder > item.selectorder) {
                        it.selectorder -= 1;
                      }
                    });
                    // const existingItem = this.metricCheckedList.find((m: any) => m.widgetNo === r.widgetNumber);
                    // const submetricname = r.metric.sublist.filter((i: any) => i.isDropdown).map((i: any) => i.subWidgetName)[0];
                    // const existingMetricIndex = existingItem.metric.findIndex((metric: any) => metric.submetricname === submetricname);
                    // if (existingMetricIndex !== -1) {
                    //   let subitem = existingItem.metric[existingMetricIndex].metricselected.find((m: any) => m.Level1.option === item.option);
                    //   existingItem.metric[existingMetricIndex].metricselected = existingItem.metric[existingMetricIndex].metricselected.filter((m: any) => m !== subitem);
                    // }
                    this.metricCheckedList = this.metricCheckedList.map((m: any) =>
                      (m.widgetNo === r.widgetNumber && m.page == page) ? {
                        ...m,
                        metric: m.metric.map((met: any) =>
                          met.submetricname === sub.subWidgetName ? {
                            ...met,
                            metricselected: {
                              ...met.metricselected,
                              metrics: met.metricselected.metrics.filter((metric: any) => metric.metricName !== item.option)
                            }
                          } : met
                        )
                      } : m
                    );
                    this.metricCheckedList.forEach((m: any) => {
                      if (m.widgetNo === r.widgetNumber && m.page == page) {
                        m.metric.forEach((met: any) => {
                          if (met.submetricname === sub.subWidgetName) {
                            met.metricselected.metrics.forEach((metric: any) => {
                              if (metric.selectorder > item.selectorder) {
                                metric.selectorder -= 1;
                              }
                            })
                          }
                        })
                      }
                    })
                    item.selectorder = 0;
                    const metricSelectedLength = this.metricCheckedList
                      .filter((m: any) => m.widgetNo === r.widgetNumber && m.page == page)
                      .flatMap((m: any) => m.metric)
                      .filter((met: any) => met.submetricname === sub.subWidgetName)
                      .reduce((length: number, met: any) => length + met.metricselected.metrics.length, 0);
                      let singleOptionSelected = '';
                      if(metricSelectedLength == 1){
                        singleOptionSelected = this.metricCheckedList.filter((m:any) => m.widgetNo === r.widgetNumber && m.page == page)
                        .flatMap((m:any) => m.metric)
                        .filter((met:any) => met.submetricname === sub.subWidgetName)[0].metricselected.metrics[0].metricName
                      }
                    sublist.option = metricSelectedLength < 1 ? "Not Selected" : (metricSelectedLength == 1 ? singleOptionSelected : "Multiple");
                    if (metricSelectedLength == 0) {
                      this.metricCheckedList = this.metricCheckedList.filter((m: any) => m.widgetNo !== r.widgetNumber);
                    }
                    if (metricSelectedLength >= sub.maxselect) {
                      sub.maxlimitreached = true;
                      // 
                    }
                    else {
                      sub.maxlimitreached = false;
                    }
                  }
                  break;
                }

              }
              if (row.metric.metric_select == 3 && this.metricGroupLength != 0) {
                // 
                const metricRow = this.metricCheckedList.find((m: any) => m.page == this.pageCounter && m.widgetNo == r.widgetNumber);
                let maxSelectOrder = item.Level2.reduce((max: any, item: any) => {
                  return item.selectorder > max ? item.selectorder : max;
                }, -Infinity);
                if (metricRow) {
                  const sublistOfmetric = metricRow.metric.find((s: any) => sub.subWidgetName == s.submetricname);
                  maxSelectOrder = sublistOfmetric.metricselected.metrics.reduce((max: any, item: any) => {
                    return item.selectorder > max ? item.selectorder : max;
                  },
                    0);
                }
                let maxSelectOrder1 = item.Level2.reduce((max: any, item: any) => {
                  return item.selectorder > max ? item.selectorder : max;
                }, -Infinity);
                // change to be done here 
                if (item.option == "METRIC GROUPS") {
                  item.Level2.forEach((m: any) => {
                    m.isSelected = false;
                  })
                }
                for (let i = 0; i < item.Level2.length; i++) {
                  // if(item.option=="METRIC GROUP" && item.option==lev1.option){

                  // }
                  if (lev1.option == item.option) {
                    if (item.Level2[i] == lev) {
                      // 
                      item.Level2[i].isSelected = event.target.checked;
                      if (lev1.option == "METRIC GROUP") {
                        item.Level2.forEach((ii: any) => {
                          if (ii.option != item.Level2[i].option) {
                            ii.isSelected = false;
                          }
                        })
                      }
                      if (event.target.checked) {
                        item.Level2[i].selectorder = maxSelectOrder + 1;
                      } else {
                        item.Level2.forEach((it: any) => {
                          if (it.selectorder > item.Level2[i].selectorder) {
                            it.selectorder -= 1;
                          }
                        });
                        item.Level2[i].selectorder = 0;
                      }
                      if (event.target.checked) {
                        this.addOrUpdateMetric3(r, item, lev, page);
                        const metricsLength = this.metricCheckedList
                          .filter((m: any) => m.widgetNo === r.widgetNumber && m.page == page)
                          .flatMap((m: any) => m.metric)
                          .filter((met: any) => met.submetricname === sub.subWidgetName)
                          .reduce((length: number, met: any) => length + met.metricselected.metrics.length, 0);
                        const metricsList = this.metricCheckedList
                          .filter((m: any) => m.widgetNo === r.widgetNumber && m.page === page)
                          .flatMap((m: any) => m.metric)
                          .filter((met: any) => met.submetricname === sub.subWidgetName)
                          .flatMap((met: any) => met.metricselected.metrics);
                        const groups = this.metricCheckedList
                          .filter((m: any) => m.widgetNo === r.widgetNumber && m.page == page)
                          .flatMap((m: any) => m.metric)
                          .filter((met: any) => met.submetricname === sub.subWidgetName)
                          .flatMap((met: any) => met.metricselected.groups);
                        // 
                        sublist.option = groups[0] == "" ? (metricsLength < 1 ? "Not Selected" : (metricsLength == 1 ? metricsList[0].metricName : "Multiple")) : groups[0];
                        // 
                        if (metricsLength >= sub.maxselect) {
                          sub.maxlimitreached = true;
                        }
                        else {
                          sub.maxlimitreached = false;
                        }


                      }
                      if (!event.target.checked) {
                        this.metricCheckedList = this.metricCheckedList.map((m: any) =>
                          (m.widgetNo === r.widgetNumber && m.page == page) ? {
                            ...m,
                            metric: m.metric.map((met: any) =>
                              met.submetricname === sub.subWidgetName ? {
                                ...met,
                                metricselected: {
                                  ...met.metricselected,
                                  metrics: met.metricselected.metrics.filter((metric: any) => metric.metricName !== item.Level2[i].option)
                                }
                              } : met
                            )
                          } : m
                        );
                        // 
                        const metricsLength = this.metricCheckedList
                          .filter((m: any) => m.widgetNo === r.widgetNumber && m.page == page)
                          .flatMap((m: any) => m.metric)
                          .filter((met: any) => met.submetricname === sub.subWidgetName)
                          .reduce((length: number, met: any) => length + met.metricselected.metrics.length, 0);
                        const metricsList = this.metricCheckedList
                          .filter((m: any) => m.widgetNo === r.widgetNumber && m.page === page)
                          .flatMap((m: any) => m.metric)
                          .filter((met: any) => met.submetricname === sub.subWidgetName)
                          .flatMap((met: any) => met.metricselected.metrics);
                        const groups = this.metricCheckedList
                          .filter((m: any) => m.widgetNo === r.widgetNumber && m.page == page)
                          .flatMap((m: any) => m.metric)
                          .filter((met: any) => met.submetricname === sub.subWidgetName)
                          .flatMap((met: any) => met.metricselected.groups);
                        // // console.group(metricsLength, groups);
                        sublist.option = groups[0] == "" ? (metricsLength < 1 ? "Not Selected" : (metricsLength == 1 ? metricsList[0].metricName : "Multiple")) : groups[0];

                        if (metricsLength >= sub.maxselect) {
                          sub.maxlimitreached = true;
                        }
                        else {
                          sub.maxlimitreached = false;
                        }
                        // 
                      }
                      break;
                    }
                    else {
                      // 
                      // 
                      if (lev1.option == item.option && lev1.option == "METRIC GROUP") {
                        item.Level2[i].isSelected = false;
                      }
                    }
                  }
                  else {
                    item.Level2.forEach((it: any) => {
                      it.isSelected = false;
                      it.selectorder = 0;
                    })
                  }
                }
              }
            }
          }
        })
      }

      // 
    });
    // 
    // 
  }

  resetmetricselections(widgetNo: any, subWidgetName: any, metric: any, metricdata: any, page: any, i: any, lev1Option: any) {
    
    //reseting trendDiv flag for enabling disbling trend
    
    if(subWidgetName=="NA"){
      this.tableData.forEach((row: any) => {
        if (row.widgetNumber == widgetNo) {
          row.trend=false;
          row.trendDiv = false;
        }
      })
    }
    

    // --------------------------------------------------------


    this.searchmetric = "";
    // // 
    // 
    i.maxlimitreached = false;
    // 
    if (metric.metric_select != 3 || this.metricGroupLength == 0) {
      metricdata.forEach((item: any) => {
        item.isSelected = false;
        item.selectorder = 0;
      });
      metric.sublist.forEach((m: any) => {
        if (m.subWidgetName == subWidgetName) {
          m.filteredoptions = metricdata;
          m.option = "Not Selected";
        }
      })
      this.metricCheckedList = this.metricCheckedList.map((item: any) =>
        (item.widgetNo === widgetNo && item.page === page) ? { ...item, metric: item.metric.filter((m: any) => m.submetricname !== subWidgetName) } : item
      ).filter((item: any) => item.metric.length > 0 || item.widgetNo !== 1);
    }
    else {
      // 
      metricdata.forEach((item: any) => {
        if (item.option == lev1Option) {
          item.isDropdownOpen = true;
          item.Level2.forEach((lev2: any) => {
            lev2.isSelected = false;
            lev2.selectorder = 0;
          })
        }
      }
      );
      metric.filteredoptions = metricdata;
      metric.sublist.forEach((m: any) => {
        if (m.subWidgetName == subWidgetName) {
          m.filteredoptions = metricdata;
          m.option = "Not Selected";
        }
      })
      // Define the widget number and submetric name to remove
      const widgetNumberToRemove = widgetNo;
      const submetricNameToRemove = subWidgetName;

      // Update the metricCheckedList

      this.metricCheckedList = this.metricCheckedList.map((m: any) => {
        if (m.widgetNo === widgetNumberToRemove && m.page === page) {
          return {
            ...m,
            metric: m.metric.map((met: any) => {
              if (met.submetricname === submetricNameToRemove) {
                return {
                  ...met,
                  metricselected: {
                    ...met.metricselected,
                    metrics: [], // Remove all items from metrics
                    groups: []
                  }
                };
              }
              return met;
            }).filter((met: any) => met.metricselected.metrics.length > 0)
          };
        }
        return m;
      }).filter((m: any) => m.metric.length > 0);

    }
    // 
  }

  addOrUpdateMetric(r: any, item: any, page: any) {
    const existingItem = this.metricCheckedList.find((m: any) => m.widgetNo === r.widgetNumber && m.page === page);
    const submetricname = r.metric.sublist.filter((i: any) => i.isDropdown).map((i: any) => i.subWidgetName)[0];
    const metricselect = r.metric.sublist.filter((i: any) => i.isDropdown).map((i: any) => i.metric_Select)[0];
    // // 
    const newMetric = {
      submetricname: submetricname,
      metricselected:
      {
        groups: "",
        metrics: [{ metricName: item.option, selectorder: item.selectorder, is_brandanalysis: item.isBrandAnalysis }]
      }
    };

    if (existingItem) {
      // If the item exists, update its metric
      const existingMetricIndex = existingItem.metric.findIndex((metric: any) => metric.submetricname === submetricname);
      if (existingMetricIndex !== -1) {
        // Update existing metric
        if (item.option == "METRIC GROUP") {
          existingItem.metric[existingMetricIndex].metricselected.groups = item.option;
        }
        if (item.option != "METRIC GROUP") {
          if (metricselect != 1) {
            const subexistingMetric = existingItem.metric[existingMetricIndex].metricselected.metrics.find(
              (metric: any) => metric.metricName === item.option
            );

            if (!subexistingMetric) {
              existingItem.metric[existingMetricIndex].metricselected.metrics.push({
                metricName: item.option,
                selectorder: item.selectorder,
                is_brandanalysis: item.isBrandAnalysis
              });
            }
            // existingItem.metric[existingMetricIndex].metricselected.metrics.push({ metricName: item.option, selectorder: item.selectorder });
          }
          else {

          }
        }
      } else {
        // Add new metric to the existing item
        existingItem.metric.push(newMetric);
      }
    }
    else {
      // If the item does not exist, push a new item
      this.metricCheckedList.push({
        page: page,
        widgetNo: r.widgetNumber,
        metric: [newMetric],
        metric_select: r.metric.metric_select
      });
    }
  }

  addOrUpdateMetric3(r: any, item: any, lev: any, page: any) {
    // // 
    // // 
    // // 
    if (r.metric.metric_select == 3 && this.metricGroupLength != 0) {
      const existingItem = this.metricCheckedList.find((m: any) => m.widgetNo === r.widgetNumber && m.page === page);
      const submetricname = r.metric.sublist.filter((i: any) => i.isDropdown).map((i: any) => i.subWidgetName)[0];
      // 
      const newMetric = {
        submetricname: submetricname,
        metricselected:
        {
          groups: item.option == "METRIC GROUP" ? item.Level2.filter((m: any) => m.isSelected === true).map((m: any) => m.option)[0] : "",
          metrics: item.option != "METRIC GROUP" ? (item.Level2.filter((m: any) => m.isSelected === true).map((m: any) => m.option).length > 0 ? [{ metricName: lev.option, selectorder: lev.selectorder, is_brandanalysis: lev.isBrandAnalysis }] : []) : []
        }
      };

      if (existingItem) {
        // If the item exists, update its metric
        const existingMetricIndex = existingItem.metric.findIndex((metric: any) => metric.submetricname === submetricname);
        if (existingMetricIndex !== -1) {
          // Update existing metric
          if (item.option == "METRIC GROUP") {
            existingItem.metric[existingMetricIndex].metricselected.groups = lev.option;
            existingItem.metric[existingMetricIndex].metricselected.metrics = [];
          }
          if (item.option != "METRIC GROUP") {
            existingItem.metric[existingMetricIndex].metricselected.groups = "";
            existingItem.metric[existingMetricIndex].metricselected.metrics.push({ metricName: lev.option, selectorder: lev.selectorder, is_brandanalysis: lev.isBrandAnalysis });
          }
        } else {
          // Add new metric to the existing item
          existingItem.metric.push(newMetric);
        }
      }
      else {
        // If the item does not exist, push a new item
        this.metricCheckedList.push({
          page: page,
          widgetNo: r.widgetNumber,
          metric: [newMetric],
          metric_select: r.metric.metric_select
        });
      }
    }
    // 
  }

  pageTableSubmit: any = [];
  isSubmitted: boolean = false;
  submit() {
    // 
    this._loaderService.showLoader();
    const pageIndex = this.pageTableData.findIndex((data: any) => data.pageNumber === this.pageCounter);
    if (pageIndex !== -1) {
      this.pageTableData[pageIndex].pagewidgetdetails = JSON.parse(JSON.stringify(this.tableData));
    } else {
      this.pageTableData.push({
        pageNumber: this.pageCounter,
        pagewidgetdetails: JSON.parse(JSON.stringify(this.tableData))
      });
    }
    this.loadOtherPagesData();
    // 
    // 

    this.pageTableSubmit = JSON.parse(JSON.stringify(this.pageTableData))

    this.pageTableSubmit.forEach((pageData: any) => {
      pageData.pagewidgetdetails = JSON.parse(JSON.stringify(pageData.pagewidgetdetails))
      // const matchingMetric = this.metricCheckedList.find((metric: any) => metric.page === pageData.pageNumber);
      const matchingMetrics = this.metricCheckedList.filter((metric: any) => metric.page === pageData.pageNumber);
      if (matchingMetrics) {
        // Execute your code here when a match is found
        // // 
        // 
        pageData.pagewidgetdetails.forEach((row: any) => {
          row.metric = []
        })
        matchingMetrics.forEach((matchingMetric: any) => {

          const rowdata = pageData.pagewidgetdetails.find((row: any) => row.widgetNumber === matchingMetric.widgetNo);
          if (rowdata) {
            rowdata.metric = matchingMetric.metric
          }
          else {
            rowdata.metric = []
          }
        })
        this._loaderService.hideLoader();
        // Example: Update the tableData or perform other actions
        // pageData.tableData = this.tableData;

        // Add any other code you want to execute when a match is found
      }
    });

    // 
    // 
    let data = {
      data: {
        clientName: this.clientDetails.clientDetails.client_name,
        snapshotName: this.clientDetails.clientDetails.study,
        snapshotType: this.selectedSnapshotType.name == undefined ? "NA" : this.selectedSnapshotType.name,
        sections: this.selectedSection == undefined ? "NA" : this.selectedSection.name,
        subsection: this.selectedSubsection == undefined ? "NA" : this.selectedSubsection.name,
        widgetPageConfiguration: this.pageTableSubmit
      },
      mode: !this.isExisting ? "Insert" : "Update",
    }
    // 
    // 

    this._configData.addWidgetLibraryConfiguration(data).subscribe((r: any) => {
      // 
      if (r.Data == '"Saved Successfully"') {
        this.showErrorPopUp = true;
        this.popUpTitle = "Info";
        this.popUpMessage = "Saved Successfully";
        this.isSubmitted = true;
        this.renderWidgetConfigurationOnSubmit();
      }
      else if (r.Data == '"Updated Successfully"') {
        this.showErrorPopUp = true;
        this.popUpTitle = "Info";
        this.popUpMessage = "Updated Successfully";
        this.isSubmitted = true;
        this.renderWidgetConfigurationOnSubmit();
      }
      else {
        this.showErrorPopUp = true;
        this.popUpTitle = "Error";
        this.popUpMessage = "Failed to Submit";
        this.isSubmitted = false;
      }
    })

    this.checkTableData = JSON.parse(JSON.stringify(this.tableData));
    this.tableClicked = false;

  }

  onCloseIconClick(closePopUp: string): void {
    if (closePopUp == 'false') {
      this.errorheaderTitle = '';
      this.showErrorPopUp = false;
    }
  }

  saveChanges = true;
  onCloseIconConfirmationPopupClicked(closePopUp: string): void {
    if (closePopUp == 'false') {
      this.errorheaderTitle = '';
      this.showConfirmationPopUp = false;
      this.tableClicked = false;
      // 
      if (this.metricCheckedList.length > this.metricheckedlistLengthBeforeSubmit) {
        this.metricCheckedList.splice(this.metricheckedlistLengthBeforeSubmit);
      }
      // 
      setTimeout(() => {
        this.saveChanges = false;
        this.pageTableData = [];
        this.tableData = [];
        this.generateTableData();
      }, 100);
    }
  }

  openPdfInNewTab() {
    const pdfUrl = 'assets/ImagesSnapshot/infoMapping/infoDummy.pdf';
    window.open(pdfUrl, '_blank');
  }

  tableClicked: any = false;
  metricheckedlistLengthBeforeSubmit: any;
  checkTableData: any;
  onPageClicked() {
    if (this.tableData.length > 0) {
      this.checkTableData = JSON.parse(JSON.stringify(this.tableData));
      // 
      this.tableClicked = true;
      this.metricheckedlistLengthBeforeSubmit = this.metricCheckedList.length
      // 
    }
  }

  onCloseOverlay() {
    this.showConfirmationPopUp = false;
    setTimeout(() => {
      this.showConfirmationPopUp = true;
    }, 100);
    this.showErrorPopUp = false;
    this.popUpTitle = "Alert";
    this.popUpMessage = "Your changes are not Saved...!"
    // 
    // this.tableClicked=false;
  }

  deepCompare(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }


}
